<template>
	<div class="file_bg">
		<div class="pre_bg">
			<div v-for="(item, index) in fileList" :key="item.keyId" class="pre_item" @click="preItemClick(item)">
				<div v-if="item.fileType !== '.png' && item.fileType !== '.jpg' && item.fileType !== '.jpeg'" class="pre_img">
					<span>{{ item.fileType }}</span>
					<i v-if="isEdit" class="el-icon-delete pre_delete" @click.stop="removeFile(item, index)"></i>
				</div>
				<div v-else class="pre_img">
					<img class="img_png" :src="imgPath + item.url" alt="" />
					<i v-if="isEdit" class="el-icon-delete pre_delete" @click.stop="removeFile(item, index)"></i>
				</div>
				<div class="pre_name">{{ item.name }}</div>
			</div>
		</div>
		<div v-if="isEdit && isShowBtn" class="images-list">
			<el-upload
				ref="upload"
				class="upload-demo"
				name="File"
				:accept="acceptParm"
				:action="uploadUrl"
				:headers="myHeaders"
				:before-upload="handleBeforeUpload"
				:on-success="handleSuccess"
				:on-error="handleUploadError"
				:on-remove="handleRemove"
				:on-exceed="handleExceed"
				:file-list="fileList"
				:multiple="false"
				:data="paramsData"
				:limit="fileLimit"
				:list-type="listType"
				:show-file-list="isShowFile"
			>
				<i class="el-icon-plus add_icon"></i>
				<!-- <el-button v-else size="small" type="primary">点击上传</el-button> -->
				<!-- <div v-if="showTip" slot="tip" class="el-upload__tip">只能上传{{fileTypeName || 'jpg/png'}}文件，且不超过
					{{fileSize}}MB
				</div> -->
			</el-upload>
		</div>
		<el-dialog :visible.sync="dialogVisible" title="图片预览" width="37.5rem" append-to-body>
			<img class="big_img" :src="dialogImageUrl" alt="" />
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: "ImageListUpload",
	props: {
		// 值
		value: [String, Object, Array],
		// 大小限制(MB)
		fileSize: {
			type: Number,
			default: 25
		},
		// 文件类型, 例如["doc", "xls", "ppt", "txt", "pdf"]
		fileType: {
			type: Array,
			default: () => ["png", "jpg", "jpeg"]
		},
		// 文件列表类型 text/picture/picture-card
		listType: {
			type: String,
			default: "text"
		},
		// 文件夹名称
		FileTypeId: {
			type: String,
			default: "maintainfile"
		},
		// 是否显示提示
		isShowTip: {
			type: Boolean,
			default: true
		},
		// 是否显示已上传的附件
		isShowFile: {
			type: Boolean,
			default: false
		},
		// 是否可编辑
		isEdit: {
			type: Boolean,
			default: true
		},
		// 最大允许上传个数
		fileLimit: {
			type: Number,
			default: 99
		},
		// 上传文件格式
		acceptParm: {
			type: String,
			default: ".png,.jpg,.jpeg,"
		}
	},
	data() {
		return {
			uploadUrl: "/api/sysConfig/FileManager/SaveAttachmentList", // 上传的图片服务器地址
			paramsData: {
				FileTypeId: this.FileTypeId
			}, // 上传携带的参数，看需求要不要
			fileList: [],
			tempFileList: [], // 因为 fileList为只读属性，所以用了一个中间变量来进行数据改变的交互。
			myHeaders: {},
			isShowBtn: true,
			dialogVisible: false,
			dialogImageUrl: "",
			imgPath: localStorage.getItem("filePath")
		};
	},
	watch: {
		value: {
			handler: function (newVal, oldVa) {
				this.tempFileList = newVal;
			},
			immediate: true,
			deep: true
		}
	},
	computed: {
		// 是否显示提示
		showTip() {
			return this.isShowTip && (this.fileType || this.fileSize);
		},
		fileTypeName() {
			let typeName = "";
			this.fileType.forEach((item) => {
				typeName += `${item}，`;
			});
			return typeName;
		},
		fileAccept() {
			let fileAccept = "";
			this.fileType.forEach((element) => {
				fileAccept += `.${element},`;
			});
			return fileAccept;
		}
	},
	created() {
		// this.$refs.upload.clearFiles()
		this.getToken();
		this.fileList = JSON.parse(JSON.stringify(this.value));
		this.fileList.forEach((item) => {
			if (!item.fileType) {
				item.fileType = "" + item.url.split(".").pop();
			}
			if (!item.fileType.includes(".")) {
				item.fileType = "." + item.fileType;
			}
		});
		if (this.fileList.length >= this.fileLimit) {
			this.isShowBtn = false;
		}
	},
	methods: {
		// 获取token
		getToken() {
			let token = localStorage.getItem("logintoken");
			this.myHeaders = {
				Authorization: "Bearer " + token
			};
		},

		// 文件点击
		preItemClick(file) {
			if (!file.fileType) {
				file.fileType = "" + file.url.split(".").pop();
			}
			if (!file.fileType.includes(".")) {
				file.fileType = "." + file.fileType;
			}
			if (file.fileType === ".png" || file.fileType === ".jpg" || file.fileType === ".jpeg") {
				this.dialogImageUrl = localStorage.getItem("filePath") + file.url;
				this.dialogVisible = true;
			} else {
				let fullDownloadUrl = "/api/sysConfig/DownLoad/DownLoadFile?fileName=" + encodeURIComponent(file.url);
				let temp = file.url.split("/");
				let fileInfoName = temp.pop();
				this.$preloadWeb.fileDownLoad({
					fullDownloadUrl,
					fileInfoName
				});
			}
		},

		// 删除文件
		removeFile(file, index) {
			this.fileList.splice(index, 1);
			this.$message.success("删除成功");
			this.changeFileList(this.fileList);
		},

		// 上传前校检格式和大小
		handleBeforeUpload(file) {
			// 校检文件类型
			if (this.fileType && file) {
				let fileExtension = "";
				if (file.name.lastIndexOf(".") > -1) {
					fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
				}
				const isTypeOk = this.fileType.some((type) => {
					if (file.type.indexOf(type) > -1) return true;
					if (fileExtension && fileExtension.indexOf(type) > -1) return true;
					return false;
				});
				if (!isTypeOk & file) {
					this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`);
					return false;
				}
			}
			// 校检文件大小
			if (this.fileSize && file) {
				const isLt = file.size / 1024 / 1024 < this.fileSize;
				if (!isLt) {
					this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
					return false;
				}
			}
			return true;
		},
		handleUploadError(err) {
			this.$message.error("上传失败, 请重试");
		},
		// 文件个数超出
		handleExceed() {
			this.$message.error(`超出上传文件个数,请删除以后再上传！`);
		},
		// 文件上传成功的钩子
		handleSuccess(res, file, fileList) {
			if (res.code === 1) {
				this.$message.success("上传成功");
				this.changeFileList(fileList);
			} else {
				this.$message.info(res.msg);
			}
		},
		// 文件列表移除文件时的钩子
		handleRemove(file, fileList) {
			this.changeFileList(fileList);
		},

		// 文件列表改变的时候，更新组件的v-model的文的数据
		changeFileList(fileList) {
			if (fileList.length >= this.fileLimit) {
				this.isShowBtn = false;
			} else {
				this.isShowBtn = true;
			}
			const tempFileList = fileList.map((item) => {
				let tempItem = {
					name: item.name,
					url: item.response ? item.response.data[0].filePath : item.url,
					keyId: item.response ? item.response.data[0].keyId : item.keyId,
					fileSize: item.response ? item.response.data[0].fileSize : item.fileSize,
					fileType: item.response ? item.response.data[0].postFix : item.fileType,
					createTime: item.response ? item.response.data[0].createTime : item.createTime
				};
				tempItem.fileSize = this.convertBytesToSize(tempItem.fileSize);
				return tempItem;
			});
			this.fileList = tempFileList;
			this.$emit("input", tempFileList);
		},

		// 文件大小转换
		convertBytesToSize(bytes) {
			const BYTES_IN_KILOBYTES = 1024;
			const BYTES_IN_MEGABYTES = 1048576;
			const BYTES_IN_GIGABYTES = 1073741824;

			if (bytes < BYTES_IN_KILOBYTES) {
				return `${bytes} B`;
			} else if (bytes < BYTES_IN_MEGABYTES) {
				return `${(bytes / BYTES_IN_KILOBYTES).toFixed(2)} KB`;
			} else if (bytes < BYTES_IN_GIGABYTES) {
				return `${(bytes / BYTES_IN_MEGABYTES).toFixed(2)} MB`;
			} else {
				return `${(bytes / BYTES_IN_GIGABYTES).toFixed(2)} GB`;
			}
		}
	}
};
</script>
<style scoped lang="scss">
.file_bg {
	display: flex;
	flex-wrap: wrap;
}

.pre_bg {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 20px;
}

.images-list {
	border: 1px dashed #d5d5d5;
	border-radius: 4px;
	background: #fff;
	width: 80px;
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.add_icon {
	font-size: 36px;
}

.pre_item {
	width: 80px;
	height: 80px;
	margin-bottom: 20px;

	.pre_img {
		width: 60px;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #55aaff;
		color: #55aaff;
		border-radius: 10px;
		position: relative;
		padding: 5px;
		cursor: pointer;

		.pre_delete {
			position: absolute;
			top: 0px;
			right: 0px;
			color: #ff0000;
			font-size: 18px;
		}
	}

	.pre_name {
		width: 70px;
		font-size: 12px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}

.big_img {
	width: 100%;
}

.img_png {
	max-width: 100%;
	max-height: 100%;
	object-fit: scale-down;
}
</style>
